import { Link } from './link';
import { Repository } from './repository';
import { User } from './user';

type BBIssueStateType =
  | 'new'
  | 'open'
  | 'resolved'
  | 'on hold'
  | 'invalid'
  | 'duplicate'
  | 'wontfix'
  | 'closed';

type BBIssue = {
  id: number;
  type: 'issue';
  priority: 'trivial' | 'minor' | 'major' | 'critical' | 'blocker';
  kind: 'bug' | 'enhancement' | 'proposal' | 'task';
  state: BBIssueStateType;
  repository: Repository;
  links: {
    attachments: Link;
    self: Link;
    watch: Link;
    comments: Link;
    html: Link;
    vote: Link;
  };
  reporter: User;
  assignee: User;
  title: string;
  component?: string;
  milestone?: string;
  version?: string;
  votes: number;
  watches: number;
  content: {
    raw: string;
    markup: string;
    html: string;
  };
  edited_on: Date;
  created_on: Date;
  updated_on: Date;
};

declare global {
  namespace BB {
    type Issue = BBIssue;
    type IssueStateType = BBIssueStateType;
  }
}

export type Issue = BBIssue;
export type IssueStateType = BBIssueStateType;
